export function registerServiceWorker() {
  if (!("serviceWorker" in navigator) || !import.meta.env.PROD) return;

  const activateServiceWorker = () => {
    void navigator.serviceWorker.register("/sw.js", {
      scope: "/",
      updateViaCache: "none",
    }).then(async (registration) => {
      await registration.update();
      await navigator.serviceWorker.ready;
      document.documentElement.dataset.pwaReady = "true";
    }).catch((error: unknown) => {
      document.documentElement.dataset.pwaReady = "false";
      console.warn("Não foi possível ativar o modo offline do Japa Reader.", error);
    });
  };

  if (document.readyState === "complete") {
    activateServiceWorker();
    return;
  }

  window.addEventListener("load", activateServiceWorker, { once: true });
}
